import React from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { fmtIDR } from "../../lib/api";
import { StatusBadge, ProgressBar, MODES, fmtQty, perLabel, openJobChat } from "./shared";

const Cell = ({ label, children, testId }) => (
  <div><div className="text-[9px] uppercase tracking-[0.2em] text-[#A8A8AD]">{label}</div><div data-testid={testId} className="text-sm font-semibold text-[#F5F3ED]">{children}</div></div>
);

export default function JobCard({ d, i, onTake }) {
  const can = !d.rule.blocked;
  const navigate = useNavigate();
  return (
    <div data-testid={`job-card-${d.id}`} style={{ animationDelay: `${i * 60}ms` }}
      className="job-card fade-in relative rounded-xl border border-[#D4AF37]/25 hover:border-[#D4AF37]/70 p-5 transition-colors flex flex-col">
      <div className="relative flex items-start justify-between gap-3 mb-3">
        <div className="min-w-0">
          <div className="font-mono text-[10px] tracking-widest text-[#D4AF37]">{d.job_no}{d.invited_me && <span data-testid={`job-invited-${d.id}`} className="ml-2 font-sans font-bold tracking-wider text-[9px] bg-[#D4AF37] text-[#101114] rounded-sm px-1.5 py-0.5">UNDANGAN KHUSUS</span>}</div>
          <h3 className="text-xl font-bold text-[#F5F3ED] truncate" style={{ fontFamily: "'Playfair Display', serif" }}>WTB {d.item_name}</h3>
          <div className="text-xs text-[#A8A8AD]">{d.game_name} · {d.server_name}{d.faction ? ` · ${d.faction}` : ""}</div>
        </div>
        <StatusBadge status={d.status} testId={`job-status-${d.id}`} />
      </div>
      <div className="relative flex items-baseline gap-1 mb-4">
        <span data-testid={`job-price-${d.id}`} className="text-2xl font-bold bg-gradient-to-b from-[#F2D98D] to-[#B8922A] bg-clip-text text-transparent">{fmtIDR(d.price_per_unit_idr)}</span>
        <span className="text-xs text-[#A8A8AD]">{perLabel(d.price_per_qty)}</span>
      </div>
      <div className="relative grid grid-cols-3 gap-3 mb-3">
        <Cell label="Jumlah Awal">{fmtQty(d.target_qty)}</Cell>
        <Cell label="Terambil">{fmtQty(d.taken_qty)}</Cell>
        <Cell label="Sisa" testId={`job-remaining-${d.id}`}><span className="text-[#D4AF37]">{fmtQty(d.rule.remaining)}</span></Cell>
      </div>
      <div className="relative mb-4"><ProgressBar d={d} /></div>
      <div className="relative grid grid-cols-2 gap-3 mb-4 text-xs">
        <Cell label="Mode">{MODES[d.take_mode].label}</Cell>
        <Cell label="Minimum Take">{d.take_mode === "take_all" ? "Seluruh sisa" : d.min_take ? fmtQty(d.min_take) : "—"}</Cell>
        <Cell label="Estimasi Total Sisa"><span className="text-[#D4AF37]">{fmtIDR(d.remaining_value_idr)}</span></Cell>
        {d.my_qty > 0 && <Cell label="Alokasi Saya">{fmtQty(d.my_qty)}</Cell>}
      </div>
      {d.notes && <p className="relative text-xs text-[#A8A8AD] mb-4 line-clamp-2">{d.notes}</p>}
      {d.rule.blocked && d.status === "open" && <p className="relative text-[11px] text-[#F2D98D] mb-3">{d.rule.blocked}</p>}
      <button data-testid={`job-take-${d.id}`} disabled={!can} onClick={onTake}
        className="relative mt-auto w-full rounded-sm py-3 font-bold tracking-[0.2em] text-sm transition-colors bg-[#1FA866] hover:bg-[#35C78A] text-[#06140d] disabled:bg-[#2a2b31] disabled:text-[#6b6b70] disabled:cursor-not-allowed">
        {d.status === "filled" ? "FILLED" : "TAKE ORDER"}
      </button>
      <button data-testid={`job-chat-${d.id}`} onClick={() => openJobChat(navigate, { demand_id: d.id })}
        className="relative mt-2 flex items-center justify-center gap-1.5 text-[11px] font-bold tracking-widest text-[#D4AF37] hover:text-[#F2D98D] py-1.5"><MessageCircle size={12} /> PESAN ADMIN</button>
    </div>
  );
}
